"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeUsername = void 0;
const validateUsername_1 = require("./validateUsername");
function normalizeUsername(username) {
    const { isEmailValid, isPhoneNumberValid } = validateUsername_1.validateUsername(username);
    if (isEmailValid) {
        username = username.replace(/@/g, '_');
    }
    if (isPhoneNumberValid) {
        username = username.replace(/\+/g, '_');
    }
    return username;
}
exports.normalizeUsername = normalizeUsername;
//# sourceMappingURL=normalizeUsername.js.map